import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CustomTooltip from "src/components/custom-tooltip";
import { IconButton } from "@mui/material";
import { Helmet } from "react-helmet";

const LinkedInButton = ({ user, isProfilePrivate }) => {
    const title = "Take a look at my Adadot profile!";
    const url = `https://me.adadot.com/personal-profile/${user.orgId}:${user.user_id}`;

    const handleClick = () => {
        const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            url
        )}`;

        const width = 500;
        const height = 500;
        const left = window.innerWidth / 2 - width / 2;
        const top = window.innerHeight / 2 - height / 2;

        window.open(
            linkedInShareUrl,
            "linkedin_share",
            `width=${width}, height=${height}, top=${top}, left=${left}`
        );
    };

    return (
        <>
            <Helmet>
                <meta property="og:title" content={title} />
                <meta
                    property="og:description"
                    content="Check out my Adadot developer profile featuring my stats and achievements."
                />
                <meta property="og:url" content={url} />
            </Helmet>
            <CustomTooltip
                title={
                    isProfilePrivate
                        ? "You profile is private. Enable via  your account settings"
                        : "Share link via LinkedIn"
                }
            >
                <div>
                    <IconButton
                        onClick={handleClick}
                        aria-label="linked-in-post"
                        size="small"
                        disabled={isProfilePrivate}
                    >
                        <LinkedInIcon fontSize="small" />
                    </IconButton>
                </div>
            </CustomTooltip>
        </>
    );
};

export default LinkedInButton;
